<template>
    <div class="d-flex flex-column align-items-center fade-in px-15">
    <content-header-custom title="STORE" :sub-title="subTitle" class="w-100 mxw-md px-10">
      <el-badge :value="cartCount" class="fs-20 mt-05 mr-05 pointer" @click.native="onCartClick">
        <i class="el-icon-shopping-cart-2"></i>
      </el-badge>
      </content-header-custom>
    <el-row class="px-10 w-100 mxw-md px-10 d-flex" :gutter="10">
        <el-col :span="22" class=" d-flex p-0">
          <el-input class="input-field" placeholder="Search here" v-model="criteria" @keyup.enter.native="searchItem">
            <div slot="prefix" class="d-flex align-items-center mr-20" style="color: #EF6563; cursor:pointer; width:100%; height:100%; padding: 0.35rem;" @click="searchItem">
              <svg width="20" height="20" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4167 18.2083C14.4437 18.2083 17.7083 14.9437 17.7083 10.9167C17.7083 6.88959 14.4437 3.625 10.4167 3.625C6.38959 3.625 3.125 6.88959 3.125 10.9167C3.125 14.9437 6.38959 18.2083 10.4167 18.2083Z" stroke="#EF6563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.2385 20.7385L15.4766 15.9766" stroke="#EF6563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </el-input>
        </el-col>
        <!-- icon filter -->
        <el-col :span="1">
          <div class="d-flex align-items-center" style="cursor:pointer; width:100%; height:40px" @click="filtersDrawerVisible = true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 4V8" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 12V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 4V14" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 9C19.1046 9 20 8.10457 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7C16 8.10457 16.8954 9 18 9Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 4V5" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 9V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
        </el-col>
        <!-- el col for sorting icon -->
        <el-col :span="1">
          <div  class="d-flex align-items-center fs-15" style="cursor:pointer; width:100%; height:100%">
            <el-dropdown @command="handleCommandSorting">
              <div class="el-dropdown-link">
                <div class="d-flex align-items-center fs-15">
                  <i class="el-icon-sort"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="lowestPrice">Lowest Price</el-dropdown-item>
                <el-dropdown-item command="highestPrice" >Highest Price</el-dropdown-item>
                <el-dropdown-item command="AZ">Alphabetical (A to Z)</el-dropdown-item>
                <el-dropdown-item command="ZA">Alphabetical (Z to A)</el-dropdown-item>
                <!-- reset item -->
                <el-dropdown-item command="reset">Reset</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    <div class="products-grid mt-20 w-100 mxw-md px-10" v-if="isLoaded && saleableItemsList &&  saleableItemsList.items?.length" >
      <div class="product-item" v-for="item in saleableItemsList.items" :key="item._id">
        <el-card class="item-card" shadow="hover">
          <!-- Card Image Section -->
          <div class="card-image-section">
            <el-carousel v-if="item.images && item.images.length > 0" trigger="click" height="180px">
              <el-carousel-item v-for="img in item.images" :key="img.uid">
                <img :src="img.url" alt style="object-fit: contain; width: 100%; height: 100%" />
              </el-carousel-item>
            </el-carousel>
            <el-avatar
              v-else
              class="d-flex flex-center fs-25 product-avatar"
              shape="square"
              icon="el-icon-picture"
              :size="150"
              style="object-fit: contain; width: 100%; height: 180px"
            ></el-avatar>
          </div>

          <!-- Card Content Section -->
          <div class="card-content-section">
            <div class="entity-name">
              {{getEntityName(item)}}
            </div>
            <div class="item-type">
                {{showItemType(item)}}
            </div>
            <div class="item-name">
                {{item.name}}
            </div>
            <div class="item-price">
              ${{ item.price | parsePrice }}
            </div>
            <div class="mt-05 font-light description fs-08">
              <div class="description-content" :class="{ 'expanded': item.showFullDescription }">
                {{ item.description }}
              </div>
              <div v-if="item.description && item.description.length > 100"
                   class="read-more-toggle"
                   @click="toggleDescription(item)">
                {{ item.showFullDescription ? 'Show less' : 'Read more' }}
              </div>
            </div>
            <div class="warning-messages-container" v-if="getLimitPertransactionNotes(item) || getLimitNotes(item)">
              <div v-if="getLimitPertransactionNotes(item)" class="description">
                {{ getLimitPertransactionNotes(item) }}
              </div>
              <div v-if="getLimitNotes(item)" class="description">
                {{ getLimitNotes(item) }}
              </div>
            </div>
          </div>

          <!-- Card Actions Section -->
          <div class="card-actions-section">
            <div class="card-inputs">
            <el-row :gutter="20" align="end" class="mt-10">
              <el-col :span="item.requiresSize? 12 :24" >
                <el-input-number
                  placeholder="Qty"
                  size="mini"
                  :min="getMin(item)"
                  :max="getMax(item)"
                  :controls="true"
                  controls-position="right"
                  v-model="item.qty"
                />
              </el-col>
              <el-col :span="12" v-if="item.requiresSize">
                <el-select
                  size="mini"
                  placeholder="Size"
                  v-model="item.size"
                >
                  <el-option-group
                    v-for="group in getSizeGroups(item)"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="ig in group.options"
                      :key="ig.value"
                      :label="getFormattedLabel(ig.label)"
                      :value="ig.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-col>
            </el-row>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="fixed-footer" v-if="totalPrice > 0">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col :span="12">
           <div class="total-price">Total: ${{ totalPrice | parsePrice }}</div>
         </el-col>
         <el-col :span="12">
            <el-button type="primary" class="ac-btn" @click="addToCart" block>Add to Cart</el-button>
         </el-col>
      </el-row>
    </div>

    <el-drawer
    title="Filters"
    :visible.sync="filtersDrawerVisible"
    :size="isTablet ? '100%' : '30%'"
    :with-header="true">

    <el-form :model="filterForm" label-width="120px">
      <el-collapse class="p-10 " accordion>
        <el-collapse-item name="entity">
          <template slot="title">
            <div class="d-flex justify-content-between w-100 ">
              <span>Entity</span>
              <span class="mr-10">

                <el-checkbox   v-model="checkAll" @change="handleCheckAllChange(checkAll)">Select all</el-checkbox>
              </span>
            </div>
          </template>
          <el-collapse class="inner-collapse"  accordion>
            <el-collapse-item :title="group.label"  v-for="group in organisations " :key="group.label" :name="group.label">
              <div class="grid-container-entity">
                <el-checkbox border v-for="item in group.options" v-model="selectedOrg"  @change="handleEntitySelection(item)"  :key="item._id"  :label="item.name">{{item.name}}</el-checkbox>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-collapse-item>
        <el-collapse-item title="Type" name="type">
           <div v-for="item in saleableItemTypes" :key="item.type">
            <el-checkbox v-model="filterForm.type" :label="item.type" @change="handleTypesClicked">{{item.name}}</el-checkbox>
           </div>
        </el-collapse-item>
        <el-collapse-item title="Product Types" name="productType">
          <div v-for="item in productTypes" :key="item.type">
            <el-checkbox v-model="filterForm.productType" :label="item.type">{{item.name}}</el-checkbox>
          </div>
        </el-collapse-item>
        <el-collapse-item title="Member Types" name="memberType">
          <div v-for="item in memberTypes" :key="item.type">
            <el-checkbox v-model="filterForm.memberType" :label="item.type">{{item.name}}</el-checkbox>
          </div>
        </el-collapse-item>
        <el-collapse-item title="Genders" name="gender">
            <div v-for="{value,label} in genders" :key="value">
              <el-checkbox v-model="filterForm.gender" :label="label">{{label}}</el-checkbox>
            </div>
        </el-collapse-item>
        <!-- size -->
        <el-collapse-item title="Size" name="size">
          <el-collapse class="inner-collapse"  v-for="size in allSizes" :key="size.value" accordion>
            <el-collapse-item :title="size.label" :name="size.label">
              <div class="grid-container" >
                <el-checkbox-button v-for="option in size.options" :key="option.value" v-model="filterForm.size" :label="option.value">{{option.label}}</el-checkbox-button>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <!-- button to show items -->
    <el-row class="mt-20">
      <el-col :span="24" class="d-flex justify-content-center">
        <el-button type="primary" class="ac-btn" @click="filtersDrawerVisible = false">Show Items</el-button>
        <!-- button to reset -->
        <el-button type="primary" class="ac-btn" @click="resetFilter">Reset</el-button>
      </el-col>
    </el-row>
  </el-drawer>
    <el-dialog
      title="Additional Questions"
      :visible.sync="showAnswerAdditionalQs"
    >
      <el-col>
        <el-row>
          <additional-questions
            v-for="item in saleableItemsWithAdditionalQs"
            :key="item._id"
            :value="item"
          />
        </el-row>
        <el-col></el-col>
        <el-row>
          <el-button class="mt-10" @click="() => showAnswerAdditionalQs = false">Cancel</el-button>
          <el-button class="mt-10" type="primary" @click="submitAdditionalQs">Next</el-button>
        </el-row>
      </el-col>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  productTypes,
  genders,
} from '@/utils/constants';
import { datadogRum } from '@datadog/browser-rum';
import AdditionalQuestions from './components/AdditionalQsAnswerDialog.vue';

export default {
  name: 'Store',
  data() {
    return {
      isLoaded: false,
      allSizes: [],
      windowWidth: window.innerWidth,
      saleableItemsList: undefined,
      errorMessage: '',
      subTitle: 'Select the items you want to purchase',
      criteria: '',
      productTypes,
      genders,
      filtersDrawerVisible: false,
      saleableItemTypes: [],
      memberTypes: [],
      selectedOrg: [],
      checkAll: false,
      organisations: [
        {
          label: 'State',
          options: [],
        },
        {
          label: 'Association',
          options: [],
        },
        {
          label: 'Club',
          options: [],
        },
      ],
      filterForm: {
        organisation: [],
        type: [],
        productType: [],
        memberType: [],
        gender: [],
        size: [],
      },
      showAnswerAdditionalQs: false,
      saleableItem: {},
      saleableItemsWithAdditionalQs: [],
    };
  },
  components: {
    AdditionalQuestions,
  },
  async created() {
    // resize
    window.addEventListener('resize', this.handleResize);
    this.checkAll = true;
    let customEntity = {};
    // get getEntity and getSaleableItemTypes from national store
    const entity = this.$store.getters['national/getEntity'];
    const saleableItemTypes = this.$store.getters['national/getSaleableItemTypes'];

    const memberTypes = this.$store.getters['national/getMemberTypes'];
    if (saleableItemTypes.length) {
      this.saleableItemTypes = saleableItemTypes;
    }
    if (memberTypes.length) {
      this.memberTypes = memberTypes;
    }
    if (entity) {
      customEntity = entity;
    }

    const {
      saleableItemId,
      saleableitemId,
      saleableItemid,
      saleableitemid,
    } = this.$route.query;
    const saleableItemIdToUse = saleableItemId
      || saleableitemId
      || saleableItemid
      || saleableitemid;
    console.log({
      saleableItemIdToUse
    });

    this.$store.commit('loading', true);
    try {
      if (saleableItemIdToUse) {
        console.log('Getting Saleable Items for specific item');
        const resSaleableItems = await this.$http.post('/assemble/api/v1/portal/saleable-items-list', {
          customEntity,
          filterForm: this.filterForm,
          checkAll: this.checkAll,
          saleableItemId: +saleableItemIdToUse
        });
        if (resSaleableItems.data.data) {
          this.saleableItemsList = resSaleableItems.data.data;
          this.saleableItemsList.items.sort((a, b) => a.name.localeCompare(b.name));
        }
      } else {
        console.log('Getting Saleable Items for all items');
        const resSaleableItems = await this.$http.post('/assemble/api/v1/portal/saleable-items-list', {
          customEntity,
          filterForm: this.filterForm,
          checkAll: this.checkAll
        });
        if (resSaleableItems.data.data) {
          this.saleableItemsList = resSaleableItems.data.data;
          this.saleableItemsList.items.sort((a, b) => a.name.localeCompare(b.name));
        }
      }
    } catch (error) {
      datadogRum.addError(error, {
        error_message: 'Error loading store list',
      });
      this.$message.error(error.response.data.message);
    } finally {
      this.$store.commit('loading', false);
    }

    this.$store.commit('loading', true);
    try {
      const sizeGuideListsRes = await this.$http.get('/assemble/api/v1/portal/size-guide-list');
      // const saleableItemsTypesRes = await this.$http.get('assemble/api/v1/admin/nationals/saleable-item-types');
      this.allSizes = this.getFormattedSize(sizeGuideListsRes.data.data);
      // format size, search for each option in each size group, if small, medium, large, refomat to S, M, L
      this.allSizes.forEach((size) => {
        size.options.forEach((option) => {
          if (option.label.toLowerCase().includes('small')) {
            _.assign(option, { label: 'S' });
          }
          if (option.label.toLowerCase().includes('medium')) {
            _.assign(option, { label: 'M' });
          }
          if (option.label.toLowerCase().includes('large')) {
            _.assign(option, { label: 'L' });
          }
        });
      });
      this.$store.commit('loading', false);
    } catch (error) {
      datadogRum.addError(error, {
        error_message: 'Error loading store',
      });
    } finally {
      this.$store.commit('loading', false);
    }
    await this.getOrganisations();
    // map all the options _id to filterForm.organisation
    this.organisations.forEach((group) => {
      group.options.forEach((option) => {
        // this.filterForm.organisation.push(option._id);
        this.selectedOrg.push(option.name);
      });
    });

    this.isLoaded = true;
  },
  methods: {
    // note: send check all flag as well
    handleEntitySelection(entity) {
      if (this.checkAll === true) {
        this.checkAll = false;
        this.selectedOrg = [];
      }

      if (this.filterForm.organisation.includes(entity._id)) {
        this.filterForm.organisation = this.filterForm.organisation.filter((org) => org !== entity._id);
        this.selectedOrg = this.selectedOrg.filter((org) => org !== entity.name);
        return;
      }

      // add to filterForm.organisation

      this.filterForm.organisation.push(entity._id);
      this.selectedOrg.push(entity.name);
    },
    handleCheckAllChange(val) {
      if (val) {
        this.filterForm.organisation = [];
        this.selectedOrg = [];
        _.forEach(this.organisations, (org) => {
          _.forEach(org.options, (option) => {
            if (!this.filterForm.organisation.includes(option._id)) {
              this.filterForm.organisation.push(option._id);
              this.selectedOrg.push(option.name);
            }
          });
        });
      } else {
        this.filterForm.organisation = [];
        this.selectedOrg = [];
      }
    },
    async getOrganisations() {
      const entity = this.$store.getters['national/getEntity'];
      if (entity && entity._id) {
        // check the level
        const { level } = entity;
        if (level === 'state') {
          // remove the first item in the array

          const assocResponse = await this.$http.get('/assemble/api/v1/portal/nationals/associations');
          const clubResponse = await this.$http.get('/assemble/api/v1/portal/nationals/clubs');
          this.organisations[1].options = assocResponse.data.data;
          this.organisations[2].options = clubResponse.data.data;
          this.organisations.shift();
        } else if (level === 'association') {
          const clubResponse = await this.$http.get('/assemble/api/v1/portal/nationals/clubs');
          this.organisations[2].options = clubResponse.data.data;
          // remove the first two items in the array of organisations
          this.organisations.shift();
          this.organisations.shift();
        } else if (level === 'club') {
          this.organisations = [];
        }
      } else {
        const stateResponse = await this.$http.get('/assemble/api/v1/portal/nationals/states');
        const assocResponse = await this.$http.get('/assemble/api/v1/portal/nationals/associations');
        const clubResponse = await this.$http.get('/assemble/api/v1/portal/nationals/clubs');
        this.organisations[0].options = stateResponse.data.data;
        this.organisations[1].options = assocResponse.data.data;
        this.organisations[2].options = clubResponse.data.data;
      }
    },

    getLimitPertransactionNotes(item) {
      const { maxTransactionLimit, minTransactionLimit, hasTransactionLimit } = item;
      if (!hasTransactionLimit) return '';

      if (maxTransactionLimit && minTransactionLimit) {
        return `Limit ${minTransactionLimit} - ${maxTransactionLimit} per transaction`;
      }
      if (maxTransactionLimit) {
        return `Limit ${maxTransactionLimit} per transaction`;
      }
      if (minTransactionLimit) {
        return `Minimum ${minTransactionLimit} per transaction`;
      }
      return '';
    },
    getLimitNotes(item) {
      const { remainingQty, hasLimit, qty } = item;
      if (!hasLimit) return '';
      if (remainingQty >= 0) {
        const cart = this.$store.getters['cart/directSaleableItems'];
        const cartItem = cart.find((ci) => ci._id === item._id);
        if (cartItem) {
          const available = remainingQty - (qty || 0) - cartItem.qty;
          return `${available} pieces available`;
        }
        const available = remainingQty - (qty || 0); // Ensure qty is treated as 0 if undefined
        return available > 0 ? `${available} pieces available` : 'Out Of Stock';
      }
      return '';
    },
    getMin(item) {
      const { minTransactionLimit, hasTransactionLimit } = item;
      if (minTransactionLimit && hasTransactionLimit) {
        const cart = this.$store.getters['cart/directSaleableItems'];
        const cartItem = cart.find((ci) => ci._id === item._id);
        if (cartItem) {
          return minTransactionLimit === 1 ? 0 : minTransactionLimit - cartItem.qty;
        }
        return minTransactionLimit === 1 ? 0 : minTransactionLimit;
      }

      return 0;
    },
    getMax(item) {
      const {
        maxTransactionLimit, remainingQty, hasTransactionLimit, hasLimit
      } = item;
      let actualRemainingQty = remainingQty;
      const cart = this.$store.getters['cart/directSaleableItems'];
      const cartItem = cart.find((ci) => ci._id === item._id);
      if (cartItem) {
        actualRemainingQty = remainingQty - cartItem.qty;
      }
      if (maxTransactionLimit && actualRemainingQty && hasTransactionLimit && hasLimit) {
        return Math.min(maxTransactionLimit, actualRemainingQty);
      } if (maxTransactionLimit && hasTransactionLimit) {
        return maxTransactionLimit;
      } if (actualRemainingQty >= 0 && hasLimit) {
        return actualRemainingQty;
      }

      return 999;
    },
    toggleDescription(item) {
      this.$set(item, 'showFullDescription', !item.showFullDescription);
    },
    handleCommandSorting(command) {
      switch (command) {
        case 'lowestPrice':
          this.saleableItemsList.items.sort((a, b) => a.price - b.price);
          break;
        case 'highestPrice':
          this.saleableItemsList.items.sort((a, b) => b.price - a.price);
          break;
        case 'AZ':
          this.saleableItemsList.items.sort((a, b) => a.name.localeCompare(b.name));
          break;
        case 'ZA':
          this.saleableItemsList.items.sort((a, b) => b.name.localeCompare(a.name));
          break;
        case 'reset':
          this.saleableItemsList.items.sort((a, b) => a.name.localeCompare(b.name));
          break;
        default:
          break;
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    getFormattedSize(allSizesDefault) {
      const formatted = allSizesDefault.map((type) => {
        const options = type.options.map((op) => op.options);
        _.assign(type, { options: _.flattenDeep(options) });
        return type;
      });
      return formatted;
    },
    async resetFilter() {
      this.filterForm = {
        organisation: [],
        type: [],
        productType: [],
        memberType: [],
        gender: [],
        size: [],
      };
      await this.searchItem();
      this.filtersDrawerVisible = false;
    },
    getSizeGroups(row) {
      return row.sizeList && row.sizeList.length > 0 ? row.sizeList : this.allSizes;
    },
    getFormattedLabel(label) {
      if (label.toLowerCase().includes('small')) {
        return 'S';
      }
      if (label.toLowerCase().includes('medium')) {
        return 'M';
      }
      if (label.toLowerCase().includes('large')) {
        return 'L';
      }
      return label;
    },
    showItemType(item) {
      const type = this.saleableItemTypes.find((t) => t.type === item.type);
      return type ? type.name : '';
    },
    handleTypesClicked() {
      this.searchItem();
    },
    async searchItem() {
      let customEntity = {};
      const entity = this.$store.getters['national/getEntity'];
      if (entity) {
        customEntity = entity;
      }
      this.$store.commit('loading', true);
      const resSaleableItems = await this.$http
        .post('/assemble/api/v1/portal/saleable-items-list', {
          criteria: this.criteria,
          customEntity,
          filterForm: this.filterForm,
          checkAll: this.checkAll
        });
      this.saleableItemsList = resSaleableItems.data.data;
      this.$store.commit('loading', false);
      this.isLoaded = true;
    },
    onCartClick() {
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      if (this.cartCount > 0) this.$router.push({ name: pathName });
    },
    submitAdditionalQs() {
      // Check if all required questions are answered
      const allRequiredAnswered = this.saleableItemsWithAdditionalQs.every((item) => item.additionalQs.every((q) => {
        if (!q.required) return true;
        const answer = item.meta[q.metaField];
        if (q.type === 3) { // File upload
          return Array.isArray(answer) && answer.length > 0;
        }
        if (q.type === 2 && q.multiDropdownSelect) { // Multi-select dropdown
          return Array.isArray(answer) && answer.length > 0;
        }
        return answer !== undefined && answer !== null && answer !== '';
      }));

      if (allRequiredAnswered) {
        this.showAnswerAdditionalQs = false;
        this.addToCartProcess();
      } else {
        // Show an error message
        this.$notify({
          title: 'Error',
          message: 'Please answer all required additional questions before adding to cart.',
          type: 'error',
        });
      }
    },
    addToCart() {
      let hasAdditionalQs = false;
      this.saleableItemsWithAdditionalQs = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.saleableItemsList.items) {
        if (item.qty > 0 && _.get(item, 'additionalQs', []).length > 0) {
          // this.saleableItem = item;
          this.saleableItemsWithAdditionalQs.push(item);
          hasAdditionalQs = true;
        }
      }
      if (hasAdditionalQs) {
        this.showAnswerAdditionalQs = true;
        // eslint-disable-next-line no-useless-return
        return;
      }
      this.addToCartProcess();
    },
    addToCartProcess() {
      const cartItems = [];
      let sizeError = false; // Flag to indicate if there's an error related to size
      this.saleableItemsList.items.forEach((item) => {
        if (item.qty > 0) {
          if (item.requiresSize && !item.size) {
            this.$notify({
              title: 'Error',
              message: `${item.name} requires size`,
              type: 'error',
            });
            sizeError = true;
            return;
          }
          // eslint-disable-next-line no-param-reassign
          item.memberDetails = this.$store.getters['user/activeMember'];
          cartItems.push({ ...item });
        }
      });
      if (sizeError) return;
      // get cart items from store
      const cartItemsFromStore = this.$store.getters['cart/directSaleableItems'];
      // check if item already in cart
      const foundExceed = cartItems.find((item) => {
        const found = cartItemsFromStore.find((itemFromStore) => itemFromStore._id === item._id);
        if (found) {
          if (found.qty + item.qty > found.remainingQty || found.qty + item.qty > found.maxTransactionLimit) {
            return true;
          }
        }
        return false;
      });
      if (foundExceed) {
        this.$notify({
          title: 'Error',
          message: `${foundExceed.name} exceeds limit, There already ${foundExceed.qty} in cart`,
          type: 'error',
        });
        return;
      }

      this.$store.commit('cart/addSaleableItem', cartItems);
      // show success message, and click to go to payment page
      this.$notify({
        title: 'Success',
        message: 'Item added to cart',
        type: 'success',
      });

      // clear qty
      this.saleableItemsList.items.forEach((item) => {
        this.$set(item, 'qty', 0);
        this.$set(item, 'size', '');
      });
      // this.$router.push('payment');
    },
    getEntityName(item) {
      if (!item.orgtree) return '';

      // Find the smallest entity in the hierarchy (club > association > state > national)
      if (item.orgtree.club) {
        return item.orgtree.club.name;
      } if (item.orgtree.association) {
        return item.orgtree.association.name;
      } if (item.orgtree.state) {
        return item.orgtree.state.name;
      } if (item.orgtree.national) {
        return item.orgtree.national.name;
      }

      return '';
    },
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    cartCount() {
      return this.$store.getters['cart/counts'];
    },

    totalPrice() {
      let total = 0;
      if (this.saleableItemsList && this.saleableItemsList.items) {
        this.saleableItemsList.items.forEach((item) => {
          const qty = item.qty ? item.qty : 0;
          total += item.price * qty;
        });
      }
      return total;
    },
    isTablet() {
      return this.windowWidth <= 1024;
    },
  },
  watch: {
    filterForm: {
      handler() {
        this.searchItem();
      },
      deep: true,
    },
  },
  filters: {
    parsePrice(val) {
      return (val / 100).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input-number {
    width: 100%;
  }

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  align-items: stretch;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  @media (min-width: 1025px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
}

.product-item {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.item-card {
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 1px 3px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 0, 0, 0.12);
  }

  // Ensure card body takes full height
  ::v-deep .el-card__body {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }

  .card-image-section {
    flex-shrink: 0;
    border-radius: 8px 8px 0 0;
    overflow: hidden;
    position: relative;

    ::v-deep .el-carousel {
      border-radius: 8px 8px 0 0;

      .el-carousel__item {
        border-radius: 8px 8px 0 0;

        img {
          transition: transform 0.3s ease;
        }
      }
    }

    .product-avatar {
      background: #F5F5F7;
      border: 2px solid rgba(0, 0, 0, 0.04);
      border-radius: 8px 8px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #8e8e93;
    }
  }

  .card-content-section {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    padding: 16px 0;

    .item-name {
      font-size: 18px;
      font-weight: 600;
      color: #1f2937;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .item-price {
      font-size: 20px;
      font-weight: 700;
      color: var(--highlight-color, #409eff);
      margin-bottom: 12px;
    }

    .entity-name {
      font-size: 14px;
      color: #6b7280;
      margin-bottom: 4px;
      font-weight: 500;
    }

    .item-type {
      font-size: 13px;
      color: #9ca3af;
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  }

  .card-actions-section {
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);

    .card-inputs {
      .el-input-number {
        ::v-deep .el-input__inner {
          border-radius: 8px;
          border-color: #e2e8f0;
          transition: all 0.2s ease;

          &:focus {
            border-color: var(--highlight-color, #409eff);
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
          }
        }
      }

      .el-select {
        ::v-deep .el-input__inner {
          border-radius: 8px;
          border-color: #e2e8f0;
          transition: all 0.2s ease;

          &:focus {
            border-color: var(--highlight-color, #409eff);
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
          }
        }
      }
    }
  }

  .warning-messages-container {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    padding: 8px 12px;
    background: #fef3cd;
    border-radius: 6px;
    border-left: 3px solid #f59e0b;

    .description {
      font-size: 12px;
      color: #92400e;
      line-height: 1.4;
      margin: 2px 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .description{
    margin-top: 8px;
    .description-content {
      font-size: 14px;
      color: #6b7280;
      line-height: 1.5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      max-height: 4.5em;
      transition: max-height 0.3s ease;

      &.expanded {
        max-height: none;
        -webkit-line-clamp: unset;
        line-clamp: unset;
        display: block;
      }
    }

    .read-more-toggle {
      color: var(--highlight-color, #409eff);
      cursor: pointer;
      font-size: 12px;
      margin-top: 6px;
      font-weight: 500;
      transition: color 0.2s ease;

      &:hover {
        color: var(--highlight-color-dark, #337ecc);
        text-decoration: underline;
      }
    }
  }
}
.fixed-footer {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 999;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12), 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 20px 24px;
  min-width: 280px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 12px 40px rgba(0, 0, 0, 0.15), 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

  .el-button {
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.2s ease;

    &.ac-btn {
      background: linear-gradient(135deg, var(--highlight-color, #409eff), var(--highlight-color-light, #66b1ff));
      border: none;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0px 4px 12px rgba(64, 158, 255, 0.4);
      }
    }
  }

  .total-price {
    font-size: 18px;
    font-weight: 700;
    color: #1f2937;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
.grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(40px, 1fr)); /* This will create a responsive grid with columns of at least 100px wide. Adjust as needed. */
    gap: 15px; /* Adjust the gap between grid items as needed */
}
.grid-container-entity {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); /* This will create a responsive grid with columns of at least 100px wide. Adjust as needed. */
    gap: 15px; /* Adjust the gap between grid items as needed */
    margin-left: 0 !important;
}
::v-deep .el-collapse-item__header {
  // border:none;
}
// .size-collapse-wrap {
//   // border: 1px solid #ebeef5;
//   border-radius: 5px;
//   padding: 10px;
// }

::v-deep .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left:0 !important;
}
::v-deep .el-checkbox-button__inner{
  border: 1px solid #ebeef5;
  padding: 0.5rem 0.5rem;
}
::v-deep .el-collapse-item__wrap{
  border-bottom: none
}
.inner-collapse{
  border:none
}

</style>
